import { addDoc, collection, deleteDoc, doc, updateDoc } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../config/firebase.config";
import "firebase/firestore";
import { findPropositionById, findPropositionByUuid } from "./queries";
import { PropositionTheme, ReunionEvent } from "../../utils/types";

export const setProposalApproval = async (
  propositionId: string,
  approve: boolean,
  email: string | null = null
) => {
  const proposition = await findPropositionById(propositionId);

  if (!proposition) {
    return;
  }

  const newStatus = approve ? "APPROVED" : "DENIED";

  let id: string;

  let found;
  do {
    id = Math.floor(Math.random() * 1000000)
      .toString()
      .padStart(6, "0");
    found = await findPropositionByUuid(id);
  } while (found);

  const newUuid = approve ? id : proposition.uuid;
  await updateDoc(doc(db, "propositions", propositionId), {
    uuid: approve ? id : proposition.uuid,
    status: newStatus,
    statusChangedBy: email,
  });

  return newUuid;
};

export const addNewEvent = async (event: ReunionEvent) => {
  console.log(event);
  let docRef = await addDoc(collection(db, "events"), {
    ...event,
  });
  return docRef.id;
};

export const uploadEventImage = async (file: File) => {
  const fileExtension = file.name.split(".").pop() || "jpg";
  const storageRef = ref(
    storage,
    `events/${Date.now()}-${Math.random().toString(36).slice(2)}.${fileExtension}`,
  );
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
};

export const deleteEventById = async (eventId: string) => {
  await deleteDoc(doc(db, "events", eventId));
};

export const addNewTheme = async (
  theme: Omit<PropositionTheme, "id">,
): Promise<string> => {
  const payload: Record<string, unknown> = {
    name: theme.name,
    color: theme.color,
  };
  if (theme.imageUrl && theme.imageUrl.trim()) {
    payload.imageUrl = theme.imageUrl.trim();
  }
  const docRef = await addDoc(collection(db, "themes"), payload);
  return docRef.id;
};
